<template>
  <div class="layer-portal">
    <transition :name="maximized ? '' : 'modal-fade'">
      <div
        v-if="visible"
        class="layer-overlay"
        :class="{
          'layer-overlay--maximized': maximized,
          'layer-overlay--backdrop': !maximized
        }"
        :style="{ zIndex }"
        role="dialog"
        aria-modal="true"
        @click.self="onBackdropClick"
      >
        <slot />
      </div>
    </transition>
  </div>
</template>

<style scoped>
/* .layer-portal — transparent host element moved to document.body on mount */

.layer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.layer-overlay--backdrop {
  background-color: rgba(0, 0, 0, 0.5);
  padding: 32px;
  box-sizing: border-box;
}

.layer-overlay--maximized {
  display: block;
  background: white;
  overflow-y: auto;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}
</style>

<script>
import { layerStack } from '@/layout/layer-stack';

export default {
  emits: ['hide'],
  props: {
    dismissible: {
      type: Boolean,
      default: true,
    },
    maximized: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      zIndex: 0,
    };
  },
  mounted() {
    // Portal to document.body so position:fixed children are never trapped
    // inside an ancestor stacking context (e.g. virtual-scroll transform).
    // TODO: In Vue3 we can use <Teleport> instead of manually moving the element.
    document.body.appendChild(this.$el);
  },
  beforeUnmount() {
    if (this.visible) {
      layerStack.pop();
    }
    document.removeEventListener('keydown', this.handleEscKey);
    // $el was portaled to document.body; Vue removes it from the original
    // parent (which no longer holds it), so we must remove it explicitly.
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    show() {
      this.visible = true;
      this.zIndex = layerStack.push();
      document.addEventListener('keydown', this.handleEscKey);
    },
    hide() {
      if (!this.visible) return;
      this.visible = false;
      layerStack.pop();
      document.removeEventListener('keydown', this.handleEscKey);
      this.$emit('hide');
    },
    handleEscKey(e) {
      if (e.key === 'Escape' && this.visible && this.dismissible && this.zIndex === layerStack.peek()) {
        this.hide();
      }
    },
    onBackdropClick() {
      if (this.dismissible) {
        this.hide();
      }
    },
  },
};
</script>
